"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  list-style-type: decimal;\n  list-style-image: none;\n"], ["\n  list-style-type: decimal;\n  list-style-image: none;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Ul = require("./Ul");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Ol = _Ul.Ul.withComponent("ol");

var StyledOl = (0, _styledComponents2.default)(Ol).withConfig({
  displayName: "Ol__StyledOl",
  componentId: "sc-1vf643-0"
})(_templateObject);

exports.default = StyledOl;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-list/dist/components/Ol.js
// module id = 429
// module chunks = 168707334958949